module.exports = __webpack_public_path__ + "dash_20_app_assets/img/decore-left.2d9d23e0.png";